module.exports = __webpack_public_path__ + "img/user-vip-qd.1bae833a.png";